import { ActiveInactiveStatusEnum } from '../../../../shared/enums/active-inactive-status.enum';
import {
  mapBrandDtoToBrandModel,
  mapModelDtoToModelEntity,
} from '../../../../shared/utils/mapping/mapping.util';
import { mapFirmwareResponseDtoToFirmwareResponseModel } from '../../../firmware-management/utils/mapping/mapping.util';
import { CampaignOverviewDto } from '../../dtos/campaign-overview.dto';
import { CampaignRequestDto } from '../../dtos/campaign-request.dto';
import { CampaignResponseDto } from '../../dtos/campaign-response.dto';
import { VehicleReportDto } from '../../dtos/vehicle-report.dto';
import { CampaignOverviewModel } from '../../models/campaign-overview.model';
import { CampaignRequestModel } from '../../models/campaign-request.model';
import { CampaignResponseModel } from '../../models/campaign-response.model';
import { VehicleReportModel } from '../../models/vehicle-report.model';

export const mapCampaignRequestModelToCampaignRequestDto = (
  campaignRequestModel: CampaignRequestModel
): CampaignRequestDto => ({
  name: campaignRequestModel.name,
  startDate: campaignRequestModel.startDate,
  endDate: campaignRequestModel.endDate,
  wifiExpirationDate: campaignRequestModel.wifiExpirationDate,
  fotaUpdateType: campaignRequestModel.fotaUpdateType,
  serverInitiatedType: campaignRequestModel.serverInitiatedType,
  safetyRelevant: campaignRequestModel.safetyRelevant,
  maxRetryNo: campaignRequestModel.maxRetryNo,
  is5GDownloadingAllowed: campaignRequestModel.is5GDownloadingAllowed,
  description: campaignRequestModel.description,
  version: campaignRequestModel.version,
  firmwareIds: campaignRequestModel.firmwareIds,
  status:
    ActiveInactiveStatusEnum[
      campaignRequestModel.status as keyof typeof ActiveInactiveStatusEnum
    ].toString(),
  vinCriteria: campaignRequestModel.vinCriteria,
});

export const mapVehicleReportDtoToVehicleReportModel = (
  report: VehicleReportDto
): VehicleReportModel => ({
  vin: report.vin,
  lastUpdated: report.lastUpdated,
  status: report.status,
});

export const mapCampaignOverviewDtoToCampaignOverviewModel = (
  campaign: CampaignOverviewDto
): CampaignOverviewModel => ({
  id: campaign.id,
  name: campaign.name,
  firmwareNames: campaign.firmwareNames,
  startDate: campaign.startDate,
  endDate: campaign.endDate,
  model: campaign.model ? mapModelDtoToModelEntity(campaign.model) : null,
  brand: campaign.brand ? mapBrandDtoToBrandModel(campaign.brand) : null,
  status: campaign.status,
  totalVehiclesNumber: campaign.totalVehiclesNumber,
  executedVehiclesNumber: campaign.executedVehiclesNumber,
});

export const mapCampaignResponseDtoToCampaignResponseModel = (
  campaignResponse: CampaignResponseDto
): CampaignResponseModel => ({
  id: campaignResponse.id,
  name: campaignResponse.name,
  startDate: campaignResponse.startDate,
  endDate: campaignResponse.endDate,
  wifiExpirationDate: campaignResponse.wifiExpirationDate,
  fotaUpdateType: campaignResponse.fotaUpdateType,
  serverInitiatedType: campaignResponse.serverInitiatedType,
  safetyRelevant: campaignResponse.safetyRelevant,
  maxRetryNo: campaignResponse.maxRetryNo,
  is5GDownloadingAllowed: campaignResponse.is5GDownloadingAllowed,
  description: campaignResponse.description,
  version: campaignResponse.version,
  status: campaignResponse.status,
  firmwares: campaignResponse.firmwares.map(
    mapFirmwareResponseDtoToFirmwareResponseModel
  ),
  vinCriteria: campaignResponse.vinCriteria,
});
